import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../services/api";
import { GET_PROFILE, UPDATE_PASSWORD, UPDATE_PROFILE } from "../../../services/urls";

// Initial state
const initialState = {
  loading: false,
  loadingUpdate: false,
  profile: {},
  error: null,
  passwordUpdateError: null,
};

// Async thunk to fetch profile details
export const fetchProfile = createAsyncThunk(
  "user/profile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_PROFILE);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch profile"
      );
    }
  }
);

// Async thunk to update profile details
export const updateProfileApi = createAsyncThunk(
  "user/profileUpdate",
  async ({ firstName, lastName, mobile }, { rejectWithValue }) => {
    try {
      const response = await api.put(UPDATE_PROFILE, {
        firstName,
        lastName,
        mobile,
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update profile"
      );
    }
  }
);

// Async thunk to update password
export const updatePasswordApi = createAsyncThunk(
  "user/passwordUpdate",
  async ({ currentPassword, newPassword }, { rejectWithValue }) => {
    try {
      const response = await api.put(UPDATE_PASSWORD, {
        currentPassword,
        newPassword,
      });
      return response.data.data; // Assuming the response structure
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update password"
      );
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateProfileApi.pending, (state) => {
        state.loadingUpdate = true;
        state.error = null;
      })
      .addCase(updateProfileApi.fulfilled, (state, action) => {
        state.loadingUpdate = false;
      })
      .addCase(updateProfileApi.rejected, (state, action) => {
        state.loadingUpdate = false;
        state.error = action.payload;
      })// Password update states
      .addCase(updatePasswordApi.pending, (state) => {
        state.loadingUpdate = true;
        state.passwordUpdateError = null; // Reset any previous errors
      })
      .addCase(updatePasswordApi.fulfilled, (state, action) => {
        state.loadingUpdate = false;
        state.passwordUpdateError = null;
        // Optionally handle any data returned after a successful password update
      })
      .addCase(updatePasswordApi.rejected, (state, action) => {
        state.loadingUpdate = false;
        state.passwordUpdateError = action.payload; // Capture the error message for password update
      });
  },
});

export default profileSlice.reducer;
